/**
 * Holds a boolean value which can be switched to another one, but will automatically reset after the specified time.
 *
 * @param {boolean} defaultValue initial (default) value
 * @param {number} time time in milliseconds to hold the new value before reset
 * @constructor
 */
export default function BoolTimer(defaultValue, time)
{
    var value = defaultValue;
    var timeout;

    /**
     * Switches the value to the opposite of the default and sets the timer to reset it back to default.
     */
    this.switchValue = function()
    {
        value = !defaultValue;

        clearTimeout(timeout);

        timeout = setTimeout(function()
        {
            value = defaultValue;
        }, time);
    };

    /**
     * @return {Boolean} whether the current value is true
     */
    this.isTrue = function()
    {
        return value === true;
    };

    /**
     * @return {Boolean} whether the current value is false
     */
    this.isFalse = function()
    {
        return value === false;
    };
}


// WEBPACK FOOTER //
// ./web/js/util/BoolTimer.js